<template>
<div class="card">
  
  <div v-if="!hasItemInWatchList">
    <p>No measure in the watchlist yet, go to:</p>
    <ul>
      <li><router-link to="/procedureKinds">Procedures</router-link></li>
      <li><router-link to="/cdas">CDAs</router-link></li>
    </ul>
    to add items.
  </div>

  <div v-else>
    <div class="card-header" id="headingOne">
      <togglable-caret-header 
      data-bs-toggle="collapse" 
      data-bs-target="#collapseOne" 
      aria-expanded="true" 
      aria-controls="collapseOne"
      :showCaret="hasItemInWatchList"
      >
        <a>Watch List</a>
        <!--<button @click="removeAll" class="btn btn&#45;&#45;remove float-right"><font-awesome-icon icon="times-circle" class="icon&#45;&#45;remove" />Remove all</button>-->
      </togglable-caret-header>
    </div>

    <div id="collapseOne" class="collapse" v-bind:class="{ show: newestProcedure != 0 }" aria-labelledby="headingOne">
      <div class="card-body">
        <div>
          <ul class="list-group">
            <ul v-if="newestProcedure != 0 && newestProcedure in proceduresWatching" :key="newestProcedure+'-'+'00'" class="list-group proc-group">
              <span v-if="newestProcedure" class="watch-list-section-title text-capitalize">{{ getDescByCcd(newestProcedure, allData) }}
                <button class="btn btn--remove" @click="handleRemoveProc(proceduresWatching[newestProcedure], newestProcedure)"><font-awesome-icon icon="times-circle" class="icon--remove" /></button>
              </span>
              <measure-grid :range="50000" :grid="getGrid(newestProcedure)" :dates="getDatesForGrid(newestProcedure)" :procCcd="newestProcedure"></measure-grid>
            </ul>
            <template v-for="(measCcds, procCcd, index) in proceduresWatching">
              <ul v-if="procCcd != newestProcedure"
              :key="procCcd+'-'+index" class="list-group proc-group">
                <span v-if="procCcd" class="watch-list-section-title text-capitalize">{{ getDescByCcd(procCcd, allData) }}
                  <button class="btn btn--remove" @click="handleRemoveProc(measCcds, procCcd)"><font-awesome-icon icon="times-circle" class="icon--remove" /></button>
                </span>
              <measure-grid :range="50000" :grid="getGrid(procCcd)" :dates="getDatesForGrid(procCcd)" :procCcd="procCcd"></measure-grid>

  <!-- 
              <li v-for="(measCcd, index) in sortMeasCcds(measCcds)" :key="index" class="list-group-item">
                <input type="checkbox"
                class="form-check-input"
                @click="handleCheckMeasure(measCcd.id)"
                :id="measCcd.id"
                :checked="checkedMeasures[measCcd.id]"/>
                <label :for="measCcd.id">{{ measCcd.desc }}</label>
                <button @click="handleRemoveMeasure(procCcd, measCcd.id)" class="btn btn--remove float-right"><font-awesome-icon icon="times-circle" class="icon--remove" /></button>
              </li> -->
              </ul>
            </template>
            
            <!-- <li v-for="(value, measCcd, index) in measuresWatching" :key="index" class="list-group-item"> -->
              <measure-grid v-if="Object.keys(measuresWatching).length > 0" :range="50000" :grid="getGrid()" :dates="getDatesForGrid()" ></measure-grid>

              <!-- <input type="checkbox"
              class="form-check-input"
              @click="handleCheckMeasure(measCcd)"
              :id="measCcd"
              :checked="checkedMeasures[measCcd]"/>
              <label :for="measCcd">{{ getDescByCcd(measCcd, allData) }}</label>
              <button @click="handleRemoveMeasure(null, measCcd)" class="btn btn--remove float-right"><font-awesome-icon icon="times-circle" class="icon--remove" /></button> -->
            <!-- </li> -->
            
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { EventBus } from "../../../../event-bus";
  import {
    getDescByCcd,
    getMeasAndDateGrid,
    getCondensedDatesForGrid
  } from '@/data/getters'
  import {getMeasureWeightByCcd} from "../../../../data/getters";
  import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
  import MeasureGrid from './MeasuresGrid';

  export default {
    name: "watch-list",
    components: {
      'togglable-caret-header': TogglableCaretHeader,
      'measure-grid': MeasureGrid
    },    
    props: {
      newestProcedure: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        checked: '',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData'
      }),
      ...mapGetters('login/watch', {
        measuresWatching: 'getMeasuresWatching',
        proceduresWatching: 'getProceduresWatching',
        checkedMeasures: 'getCheckedMeasures',
        vitalCcds: 'getVitalSignCodes',
        checkedMeasuresOnly: 'getCheckedMeasuresOnly'
      }),
      hasItemInWatchList() {
        // console.log(this.$props)
        // console.log(this.newestProcedure, typeof this.newestProcedure)
        // console.log(this.newestProcedure)
        return (this.measuresWatching && Object.keys(this.measuresWatching).length > 0)
        || (this.proceduresWatching && Object.keys(this.proceduresWatching).length > 0);
      },
    },
    methods: {
      ...mapActions('login/watch', [
        'removeMeasure',
        'addCheckedMeasure',
        'removeCheckedMeasure',
        'removeProcedure'
      ]),
      getMeasWatchingCcds(procCcd) {
        let ccds;
        if (typeof procCcd === 'undefined' || procCcd === null) {
          ccds = Object.keys(this.measuresWatching);
        } else {
          ccds = Object.keys(this.proceduresWatching[procCcd]);
        }
        ccds = [...new Set(ccds)]
        return ccds;
      },
      getGrid(procCcd) {
        // console.log(this.justAddedProcedure())
        return getMeasAndDateGrid(this.allData, this.getMeasWatchingCcds(procCcd));
      },
      getDatesForGrid(procCcd) {
        return getCondensedDatesForGrid(this.allData, this.getMeasWatchingCcds(procCcd));
      },

      /* sort measures based on weights */
      sortMeasCcds(measCcds) {
        // value=true, measCcd,
        let sortedMeasCcds = [];
        Object.keys(measCcds).forEach(measCcd => {
          sortedMeasCcds.push({
            id: measCcd,
            desc: this.getDescByCcd(measCcd, this.allData),
            weight: getMeasureWeightByCcd(measCcd, this.allData),
          })
        });

        return _.orderBy(sortedMeasCcds, 'weight', 'desc');
      },

      /* @param measures is a collection of objects grouped by ccd */
      getDescFromMeasures(measures) {
        return measures[Object.keys(measures)[0]].desc;
      },

      /**
       * Removes measure from watch list and graph
       */
      async handleRemoveMeasure(procCcd, measCcd) {
        await this.removeCheckedMeasure(measCcd)
        await this.removeMeasure({proc: procCcd, meas: measCcd})
    },

      /**
       * Graphs measure
       * @param measCcd currently checked measurement id
       */
      async handleCheckMeasure(measCcd) {
        // remove from list and graph if checked
        if (this.checkedMeasures[measCcd]) {
          await this.removeCheckedMeasure(measCcd);
        } else {
          await this.addCheckedMeasure(measCcd);
        }
      },

      async handleRemoveProc(measCcds, procCcd) {
        for (const [key, value] of Object.entries(measCcds)){
          await this.handleRemoveMeasure(procCcd, key)
        }
        await this.removeProcedure(this.procCcd);
      },

      getDescByCcd,
    }
  }
</script>

<style scoped lang="scss">
  .watch-list-section-title {
    padding-left: 1em;
    font-weight: bold;
  }
  .list-group {
    padding: 0;
  }
  .proc-group {
    padding-left: 0;
  }
  .list-group-item {
    padding: 0.5rem 0.5rem 0.5rem 2.0rem;
    border: none;

    &:nth-child(odd) {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
  .card-header {
    padding: 0.2rem;
    background-color: #fff;

    a {
      width: 100%;
      text-align: left;
    }
 }
  .card-body {
    padding: 0;
    font-size: 0.95rem;
  }

  .btn--remove {
    background-color: transparent;
    margin: 0;
    padding: 0;
    color: #ff4444;

    &:hover {
      color: #cc0000;
    }
  }
  .icon--remove {
    font-size: 1em;

  }
</style>
